import { ApiInstance } from '@/lib/api'

export const MASK_CHAR = '*'

export type SensitiveValues = Record<string, string | null | undefined>

export const isMaskedValue = (value: unknown): boolean => typeof value === 'string' && value.includes(MASK_CHAR)

export const sensitiveQueryKey = (endpoint: string) => ['sensitive', endpoint]

export const SENSITIVE_FIELD_LABEL: Record<string, string> = {
  document: 'CPF/CNPJ',
  rg: 'RG',
  spouseDocument: 'documento do cônjuge',
  guarantorDocument: 'documento do fiador',
  borrowerDocument: 'documento de quem retirou a chave'
}

export const SENSITIVE_REASON_LABEL: Record<string, string> = {
  contract: 'para gerar o contrato',
  document: 'para gerar um documento',
  pdf: 'no PDF do contrato',
  edit: 'para editar'
}

export const sensitiveFieldLabel = (field: string): string => SENSITIVE_FIELD_LABEL[field] ?? field

export function joinLabels(labels: string[]): string {
  if (labels.length <= 1) return labels[0] ?? ''
  return `${labels.slice(0, -1).join(', ')} e ${labels[labels.length - 1]}`
}

export const sensitiveFieldsLabel = (fields: string[]): string => joinLabels(fields.map(sensitiveFieldLabel))

export function withoutMaskedValues<T extends object>(payload: T): Partial<T> {
  return Object.fromEntries(Object.entries(payload).filter(([, value]) => !isMaskedValue(value))) as Partial<T>
}

export const maskedFieldsOf = (row: object | null | undefined, fields: readonly string[]): string[] =>
  row ? fields.filter(field => isMaskedValue((row as Record<string, unknown>)[field])) : []

export async function revealSensitive(endpoint: string, fields: string[], reason?: string): Promise<SensitiveValues> {
  const { data } = await ApiInstance.post<SensitiveValues>(endpoint, { fields, ...(reason ? { reason } : {}) })
  return data
}
